(() => {
  // --- Ayarlar ---
  const CFG = {
    maxFlakes: 140,     // yoğunluk
    wind: 0.25,         // rüzgar
    drift: 0.6,         // salınım
    fallMin: 0.7,
    fallMax: 2.0,
    sizeMin: 3,
    sizeMax: 10,
    sparkle: 0.35,      // parıltı
    zIndex: 999999,     // en üst
    blur: 0.0,          // 0.6 gibi yapabilirsin
    opacity: 1
  };

  // Reduce motion açıksa kapat
  const reduceMotion =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (reduceMotion) return;

  const CANVAS_ID = "ep-crystal-snow";

  function ensureCanvas() {
    let canvas = document.getElementById(CANVAS_ID);
    if (canvas) return canvas;

    canvas = document.createElement("canvas");
    canvas.id = CANVAS_ID;
    canvas.setAttribute("aria-hidden", "true");

    // inline style -> CSS dosyası şart değil
    Object.assign(canvas.style, {
      position: "fixed",
      inset: "0",
      width: "100vw",
      height: "100vh",
      pointerEvents: "none",
      zIndex: String(CFG.zIndex),
      opacity: String(CFG.opacity)
    });

    document.body.appendChild(canvas);
    return canvas;
  }

  const DPR = Math.max(1, Math.min(2, window.devicePixelRatio || 1));
  let canvas, ctx, W = 0, H = 0;
  let flakes = [];
  let rafId = null;

  function rand(min, max) {
    return Math.random() * (max - min) + min;
  }

  function resize() {
    W = Math.max(1, window.innerWidth);
    H = Math.max(1, window.innerHeight);

    canvas.width = Math.floor(W * DPR);
    canvas.height = Math.floor(H * DPR);
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
  }

  function makeFlake(spawnTop = true) {
    const r = rand(CFG.sizeMin, CFG.sizeMax);
    return {
      x: rand(0, W),
      y: spawnTop ? rand(-H, 0) : rand(0, H),
      r,
      vy: rand(CFG.fallMin, CFG.fallMax) * (r / CFG.sizeMax + 0.35),
      vx: rand(-0.25, 0.25),
      a: rand(0, Math.PI * 2),
      va: rand(-0.02, 0.02),
      tw: rand(0.6, 1.0),
      seed: rand(0, 1000)
    };
  }

  function initFlakes() {
    flakes = [];
    const count = Math.min(CFG.maxFlakes, Math.floor((W * H) / 12000));
    for (let i = 0; i < count; i++) flakes.push(makeFlake(false));
  }

  // 6 kollu "kristal" çizimi
  function drawCrystal(x, y, r, rot, alpha) {
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(rot);

    ctx.shadowBlur = CFG.blur;
    ctx.shadowColor = "rgba(255,255,255,0.85)";

    const grad = ctx.createRadialGradient(0, 0, 0, 0, 0, r);
    grad.addColorStop(0, `rgba(255,255,255,${0.95 * alpha})`);
    grad.addColorStop(0.55, `rgba(210,240,255,${0.55 * alpha})`);
    grad.addColorStop(1, `rgba(255,255,255,0)`);

    ctx.fillStyle = grad;
    ctx.beginPath();
    ctx.arc(0, 0, r * 0.9, 0, Math.PI * 2);
    ctx.fill();

    ctx.strokeStyle = `rgba(255,255,255,${0.85 * alpha})`;
    ctx.lineWidth = Math.max(1, r * 0.12);
    ctx.lineCap = "round";

    for (let i = 0; i < 6; i++) {
      ctx.rotate(Math.PI / 3);
      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.lineTo(0, -r);

      ctx.moveTo(0, -r * 0.55);
      ctx.lineTo(r * 0.22, -r * 0.68);
      ctx.moveTo(0, -r * 0.55);
      ctx.lineTo(-r * 0.22, -r * 0.68);

      ctx.moveTo(0, -r * 0.78);
      ctx.lineTo(r * 0.16, -r * 0.9);
      ctx.moveTo(0, -r * 0.78);
      ctx.lineTo(-r * 0.16, -r * 0.9);

      ctx.stroke();
    }

    // küçük parıltı
    const sparkle = (0.35 + CFG.sparkle) * alpha;
    ctx.fillStyle = `rgba(255,255,255,${sparkle})`;
    ctx.beginPath();
    ctx.moveTo(0, -r * 0.1);
    ctx.lineTo(r * 0.1, 0);
    ctx.lineTo(0, r * 0.1);
    ctx.lineTo(-r * 0.1, 0);
    ctx.closePath();
    ctx.fill();

    ctx.restore();
  }

  function loop(t) {
    ctx.clearRect(0, 0, W, H);

    for (let i = 0; i < flakes.length; i++) {
      const f = flakes[i];

      const tw = f.tw + Math.sin(t * 0.002 + f.seed) * 0.25;
      const alpha = Math.max(0.15, Math.min(1, tw));

      f.a += f.va;
      const sway = Math.sin(t * 0.0015 + f.seed) * CFG.drift;

      f.x += (CFG.wind + f.vx + sway) * (f.r / CFG.sizeMax + 0.6);
      f.y += f.vy;

      drawCrystal(f.x, f.y, f.r, f.a, alpha);

      if (f.y > H + f.r * 2 || f.x < -60 || f.x > W + 60) {
        flakes[i] = makeFlake(true);
        flakes[i].x = rand(-20, W + 20);
      }
    }

    rafId = requestAnimationFrame(loop);
  }

  function start() {
    // body yoksa bekle
    if (!document.body) return;

    canvas = ensureCanvas();
    ctx = canvas.getContext("2d", { alpha: true });

    resize();
    initFlakes();

    // mevcut loop varsa temizle
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(loop);
  }

  // Shopify theme editor (section reload) ve normal sayfa yüklemeleri için sağlam başlatma
  const boot = () => start();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  let resizeT = null;
  window.addEventListener("resize", () => {
    clearTimeout(resizeT);
    resizeT = setTimeout(() => {
      if (!canvas || !ctx) return;
      resize();
      initFlakes();
    }, 150);
  });

  // Theme editor eventleri: bazı temalarda DOM yeniden çiziliyor
  document.addEventListener("shopify:section:load", () => start());
  document.addEventListener("shopify:section:reorder", () => start());
})();
